import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { processHeaders } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';
import { ACTION_DELETE_WORK, ACTION_DELETE_CASE_IN_CREATESTAGE } from '../../store/state/actions';

export const executeDeleteWorkRequest = (actionInPayload: Action['payload']) => {
  const { workId, context, isExternalCase } = actionInPayload;
  const routeKey = isExternalCase ? ACTION_DELETE_CASE_IN_CREATESTAGE : ACTION_DELETE_WORK;
  const { restApi, reqType } = resolveRestApi(routeKey, { ID: workId });

  return from(
    fetch(
      restApi,
      {
        method: reqType
      },
      context
    )
  ).pipe(
    map((response) => {
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders(response.headers)
      };
    }),
    logAndCatchError('Error occurred during ajax call at deleteWork Epic : ', context)
  );
};

export default {
  executeDeleteWorkRequest
};
